import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" style={{ maxWidth: 520, margin: "12vh auto", padding: 24, fontFamily: "Prompt,sans-serif", color: "#242b36" }}>
        <h1 style={{ fontSize: 24 }}>แสดงหน้านี้ไม่สำเร็จ</h1>
        <p>กรุณาลองเปิดหน้าอีกครั้ง หากกำลังทำรายการ โปรดตรวจสอบประวัติก่อนส่งรายการซ้ำ</p>
        <button type="button" onClick={() => this.setState({ failed: false })}>ลองอีกครั้ง</button>
        <a href="/home" style={{ marginLeft: 20 }}>กลับหน้าหลัก</a>
      </main>
    );
  }
}
